export default (value) => {
  if (typeof value === 'string') {
    return value.toUpperCase()
  }
  return ''
}



// WEBPACK FOOTER //
// ./src/filters/uppercase.js